import {
  createAsyncThunk,
  createSelector,
  createSlice,
  current,
  PayloadAction,
} from '@reduxjs/toolkit';
import axios from 'axios';
import type { RootState } from '../store';
import {
  Individual,
  IndividualFormData,
  IndividualSlice,
  Job,
  UserSettings,
} from '../../types/interface';
import { AppliedJob, LikedJob } from '../../types';

const initialState: IndividualSlice = {
  status: 'idle',
  error: null,
  myId: null, //individualId NOT b2c_user id
  mySignupEmail: null,
  userSettings: undefined,
  userInfo: undefined,
  orgList: [],
  newUser: false,
  activeProfile: false,
};
function getUniqueRecordsByProperty(records: any[]) {
  const uniqueRecords = [];
  const uniqueIds = new Set();

  for (const record of records) {
    const id = record.id;

    if (!uniqueIds.has(id)) {
      uniqueIds.add(id);
      uniqueRecords.push(record);
    }
  }

  return uniqueRecords;
}
const individualSlice = createSlice({
  name: 'individual',
  initialState,
  reducers: {
    setWelcomeInfo: (state, action) => {
      state.newUser = true;
      state.activeProfile = action.payload.activeProfile;
    },
    hideWelcomeInfo: (state, action) => {
      state.newUser = action.payload.newUser;
    },
    setUserData: (state, action) => {
      state.userSettings = { ...action.payload.profile };
      state.userInfo = { ...action.payload.info };
      state.myId = action.payload.profile.indId;
    },
    socketIndividualPayload: (
      state: IndividualSlice,
      action: PayloadAction<{ individual: Individual[]; isNew: boolean }>
    ) => {
      console.info('Individual Socket', action.payload);
      const { individual } = action.payload;

      //edge case for newly signed up users coming into the application
      if (state.userInfo !== undefined) updateB2CProfile();

      function updateB2CProfile() {
        if (individual[0]?.id === state.userInfo?.id!) {
          console.log('new individual!');
          console.log(individual[0]);
          state.userInfo = { ...individual[0] };
        } else {
          console.log('do nothing to individual!');
        }
      }
    },
    socketIndividualAttachmentUpdate: (
      state: IndividualSlice,
      action: PayloadAction<{ data: Individual[] }>
    ) => {
      /**
       * same thing, update userInfo swap out allIndividuals
       * verify updatedIndividual matches userId and update the relevant data.
       */
      // console.log('In Slice!')
      // console.info('Here is the stuff', action.payload);
      const updatedIndividual = action.payload.data[0];

      if (state.userInfo!.id === updatedIndividual.id) {
        console.log('UPDATE INDIVIDUAL RECORD');

        state.userInfo = { ...updatedIndividual }; //TODO IMPORTANT!!! format this to update b2c specific props
      }
    },
    updateUserProfileAndInfo: (
      state: IndividualSlice,
      action: PayloadAction<{ profile: any; info: any }>
    ) => {
      // console.info("Finish Registration");
      // console.info(action.payload);
      state.userSettings = action.payload.profile;
      state.userInfo = action.payload.info;
    },
    updateLikedJobsAndAppliedJobs: (
      state: IndividualSlice,
      action: PayloadAction<{ profile: UserSettings; jobs: Job[] }>
    ) => {
      console.warn('UpdateLikedJobsDispatch', action.payload);
      let likedJobsArr = action.payload.profile.likedJobsArr;
      let appliedJobsArr = action.payload.profile.appliedJobsArr;

      if (likedJobsArr) {
        action.payload.profile.likedJobsArr.forEach((likedJob: LikedJob) => {
          let jobObj = action.payload.jobs.find((job: Job) => job.id === likedJob.id);
          likedJob.isJobActive = jobObj ? jobObj!.isJobActive : false;
          //console.warn(likedJob);
        });
      } else {
        action.payload.profile.likedJobsArr = [];
      }

      if (appliedJobsArr) {
        action.payload.profile.appliedJobsArr?.forEach((appliedJob: AppliedJob) => {
          let jobObj = action.payload.jobs.find((job: Job) => job.id === appliedJob.id);
          appliedJob.isActive = jobObj ? jobObj!.isJobActive : false;
          console.warn(appliedJob);
        });
      } else {
        action.payload.profile.appliedJobsArr = [];
      }
      state.userSettings = action.payload.profile;
      state.userSettings.appliedJobsArr = getUniqueRecordsByProperty(
        action.payload.profile.appliedJobsArr
      );
    },
    setLikedJob: (
      state: IndividualSlice,
      action: PayloadAction<{ likedJobs: { id: string; ts: string }[]; jobs: Job[] }>
    ) => {
      console.warn('LikedJobsArr:', state.userSettings?.likedJobsArr);

      const jobs = action.payload.jobs;
      const likedJobsArr = action.payload.likedJobs;
      const updatedLikedJobs = likedJobsArr.map((rawLikedJobs: { id: string; ts: string }) => {
        return { id: rawLikedJobs.id, createdAt: rawLikedJobs.ts, isJobActive: true };
      });

      updatedLikedJobs.forEach((likedJob: LikedJob) => {
        let jobObj = jobs.find((job: Job) => job.id === likedJob.id);
        likedJob.isJobActive = jobObj ? jobObj!.isJobActive : false;
        console.warn(likedJob);
      });

      state.userSettings!.likedJobsArr = [...updatedLikedJobs];
    },
    removeLikedJob: (state: IndividualSlice, action: PayloadAction<{ jobId: string }>) => {
      let updatedLikedJobs = state.userSettings?.likedJobsArr.filter(
        (job: LikedJob) => job.id !== action.payload.jobId
      );
      state.userSettings!.likedJobsArr = [...updatedLikedJobs!];
      console.warn(state.userSettings!.likedJobsArr);
    },
    updateAppliedJobsArr: (
      state: IndividualSlice,
      action: PayloadAction<{ appliedJobsArr: AppliedJob[] }>
    ) => {
      state.userSettings!.appliedJobsArr = [...action.payload.appliedJobsArr];
    },
    setUserEmail: (state: IndividualSlice, action: PayloadAction<{ email: string }>) => {
      state.mySignupEmail = action.payload.email;
    },
  },
  extraReducers: (builder) => {},
});

export const updateIndividual = createAsyncThunk(
  'individual/updateIndividual',
  async (params: { individualObj: IndividualFormData; token: string }, { rejectWithValue }) => {
    return axios
      .put(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/individual/update/b2c`,
        params.individualObj!,
        {
          headers: {
            Authorization: `Bearer ${params.token}`,
          },
        }
      )
      .then((response) => {
        console.info('Reducer Indv Update:', response);
        return response.data;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data.errors);
      });
  }
);

export const deleteIndividualFile = createAsyncThunk(
  'individual/deleteFile',
  async (params: {
    individualId: string;
    fileRef: string;
    updatedFileRef: string[];
    provId: string;
    isMulti: boolean;
    isCerts: boolean;
    token: string;
  }) => {
    return axios
      .put(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/individual/b2c-update/file`,
        {
          individualId: params.individualId,
          fileRef: params.fileRef, //deleted files
          updatedFileRef: params.updatedFileRef, //non-deleted files only for file_attachments field.
          provId: params.provId,
          isMulti: params.isMulti,
          isCerts: params.isCerts,
          token: params.token,
        },
        {
          headers: {
            Authorization: `Bearer ${params.token}`,
          },
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        return err.message;
      });
  }
);

// fetches user and job info.
export const loadUserAndJobInfo = createAsyncThunk(
  'fetch/login-init',
  async (params: { userEmail: string; token: string }) => {
    console.log(params.userEmail);
    return axios
      .get(`${process.env.REACT_APP_SERVER_URL}/api/b2c/user/${params.userEmail}`, {
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      })
      .then((response) => {
        console.info('login-init fetch of User and Job info: ', response);
        return response.data;
      })
      .catch((err) => {
        console.warn('fetch/login-init ERR: ', err);
      });
  }
);

export const updateLikedJobsArr = createAsyncThunk(
  'individidual/updatelikedJobsArr',
  async (params: {
    myId: string;
    jobId: string;
    isLiked: boolean;
    orgId: string;
    provId: string;
    token: string;
  }) => {
    console.log(params);
    return axios
      .put(`${process.env.REACT_APP_SERVER_URL}/api/b2c/user/liked-jobs`, params, {
        headers: {
          Authorization: `Bearer ${params.token!}`,
        },
      })
      .then((response) => {
        console.info('liked-jobs-arr response: ', response);
        return response.data;
      })
      .catch((err) => {
        console.warn('liked-jobs-arr ERR: ', err);
      });
  }
);

export const updateJobAppliedArr = createAsyncThunk(
  'individidual/updateAppliedJobsArr',
  async (params: { myId: string; jobId: string; orgId: string; provId: string; token: string }) => {
    console.log(params);
    return axios
      .put(`${process.env.REACT_APP_SERVER_URL}/api/b2c/user/applied-jobs`, params, {
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      })
      .then((response) => {
        console.info('applied-jobs response: ', response);
        return response.data;
      })
      .catch((err) => {
        console.warn('applied-jobs ERR: ', err);
      });
  }
);

export const removeAppliedJob = createAsyncThunk(
  'individidual/removeAppliedJob',
  async (params: { myId: string; jobId: string; orgId: string; provId: string; token: string }) => {
    console.log(params);
    return axios
      .put(`${process.env.REACT_APP_SERVER_URL}/api/b2c/user/applied-jobs-remove`, params, {
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      })
      .then((response) => {
        console.info('applied-jobs-remove response: ', response);
        return response.data;
      })
      .catch((err) => {
        console.warn('applied-jobs-remove ERR: ', err);
      });
  }
);

export const fetchMyId = (state: RootState) => state.individual.myId;
export const fetchAccountEmail = (state: RootState) => state.individual.mySignupEmail;
export const fetchWelcomeParams = (state: RootState) => {
  return { newUser: state.individual.newUser, activeProfile: state.individual.activeProfile };
};
export const fetchUserSettings = (state: RootState) => state.individual?.userSettings!;
export const rtkMyUserSettings = (state: RootState) => state.individual.userSettings;

export const rtkFetchUserInfo = (state: RootState) => state.individual.userInfo;

export const rtkFetchUserName = (state: RootState) =>
  `${state.individual.userInfo?.firstName} ${state.individual.userInfo?.lastName}`;

export const fetchMyDetails = createSelector(
  [rtkFetchUserInfo, rtkMyUserSettings],
  (userInfo, userSettings) => {
    return {
      b2cId: userSettings?.b2cId,
      indId: userInfo?.id!,
      orgId: userInfo?.leadProviderOrgId!,
      provId: userInfo?.leadProviderId!,
      isVerified: userSettings?.isVerified!,
    };
  }
);

export const getLikedJobsArray = (state: RootState) => state.individual.userSettings?.likedJobsArr!;

export const checkIfLiked = (state: RootState, jobId: string) => {
  const isJobLiked = state.individual!.userSettings?.likedJobsArr?.find(
    (obj: LikedJob) => obj.id === jobId
  );
  return isJobLiked === undefined ? false : true;
};

export const getAppliedJob = (state: RootState, jobId: string): AppliedJob | undefined => {
  const appliedJob = state.individual.userSettings?.appliedJobsArr.find(
    (obj: AppliedJob) => obj.id === jobId
  );

  return appliedJob;
};

export const checkIfExpressedInterest = (state: RootState, jobId: string) => {
  const isJobLiked = state.individual!.userSettings?.appliedJobsArr?.find(
    (obj: AppliedJob) => obj.id === jobId
  );
  return isJobLiked === undefined ? false : true;
};

export const {
  setUserData,
  socketIndividualPayload,
  socketIndividualAttachmentUpdate,
  updateUserProfileAndInfo,
  updateLikedJobsAndAppliedJobs,
  setLikedJob,
  removeLikedJob,
  updateAppliedJobsArr,
  setUserEmail,
  setWelcomeInfo,
  hideWelcomeInfo,
} = individualSlice.actions;

export default individualSlice.reducer;
